import Rebase from 're-base';

const base = Rebase.createClass({
    apiKey: "AIzaSyAENelmyppVNA8_WGAcSpE4F1FDeb64IMo",
    authDomain: "catch-of-the-day-matt-collier.firebaseapp.com",
    databaseURL: "https://catch-of-the-day-matt-collier.firebaseio.com"
});

export default base;



/** WEBPACK FOOTER **
 ** ./src/base.js
 **/